import { apiRequestDev } from './apiRequest';

export const getConstituents = async (config, userId) => apiRequestDev(config, `/constituents/all/${userId}`);

export const getCouncillorConstituents = async (config, userId) =>
  apiRequestDev(config, `/constituents/all/councillor/${userId}`);

export const getConstituent = async (config, userId, id) => apiRequestDev(config, `/constituents/info/${userId}/${id}`);

export const getMatchingConstituents = async (config, userId, constituentId) =>
  apiRequestDev(config, `/constituents/matching/${userId}?constituent_id=${constituentId}`);

export const getMatchingCouncillorConstituents = async (config, userId, constituentId) =>
  apiRequestDev(config, `/constituents/matching/councillor/${userId}?constituent_id=${constituentId}`);

export const createConstituent = async (config, userId, name, phone, email, address, postalCode) => {
  return apiRequestDev(config, '/constituents/create', 'post', {
    user_id: userId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
  });
};

export const saveConstituent = async (config, constituentId, userId, name, phone, email, address, postalCode) => {
  return apiRequestDev(config, `/constituents/${constituentId}/update`, 'patch', {
    user_id: userId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
  });
};

export const acceptConstituent = async (config, userId, constituentId) => {
  return apiRequestDev(config, `/constituents/${constituentId}/accept`, 'patch', {
    user_id: userId,
  });
};

export const mergeConstituent = async (config, userId, constituentId, pendingConstituentId) => {
  return apiRequestDev(config, `/constituents/${pendingConstituentId}/merge`, 'patch', {
    user_id: userId,
    constituent_id: constituentId,
  });
};
